import { useParams } from "react-router-dom";
import NewsroomDetailsPage from "../components/Newsroom/NewsroomDetailsPage"
import StayInLoop from "../components/StayInLoop.js"
import { useEffect, useState } from "react";
import axios from "axios";

export default function NewsroomDetails() {
    const { slug } = useParams();
    const [newsDetailData, setNewsDetailData] = useState(null);

    const getActileDetails = async (id) => {
        try {
            const response = await axios.get(
                `https://dev.ienergydigital.com/task-api/api/newsroom/articles/${id}`
            );

            const formattedArticles = response.data.data;
            setNewsDetailData(formattedArticles);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (slug) {
            getActileDetails(slug);
        }
    }, [slug]);



    return (
        <>
            <NewsroomDetailsPage data={newsDetailData} />
            <StayInLoop />
        </>
    )
}